import React from 'react';

import { ClipboardList, MessageCircle, Hand } from 'lucide-react';
 
export default function CaseEvaluationPage() {

  return (
<div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">

      {/* SEO Meta Tags would go in the head - included as comments for reference */}

      {/* 
<title>Free Case Evaluation - Expert Legal Consultation | Car Accident Lawyers</title>
<meta name="description" content="Get a free case evaluation from experienced car accident lawyers. Connect with attorneys who handle your specific injury or crash type. No pressure, no obligation." />
<meta name="keywords" content="free case evaluation, car accident lawyer, personal injury attorney, legal consultation" />
<meta property="og:title" content="Free Case Evaluation - Expert Legal Consultation" />
<meta property="og:description" content="Get a free case evaluation from experienced car accident lawyers." />
<meta property="og:type" content="website" />
<link rel="canonical" href="https://yourwebsite.com/case-evaluation" />

      */}
<main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-24">

        {/* Header Section */}
<header className="text-center mb-12 sm:mb-16 lg:mb-20">
<h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">

            How Do I Claim My Free Case Evaluation
</h1>
</header>
 
        {/* Three Step Cards */}
<section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-12 sm:mb-16">

          {/* Step 1 */}
<article className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 p-8 sm:p-10">
<div className="flex flex-col items-center text-center">
<div className="w-12 h-12 rounded-full border-2 border-red-400 flex items-center justify-center mb-6 self-start">
<span className="text-red-400 font-semibold text-lg">1</span>
</div>
<div className="w-16 h-16 mb-6">
<ClipboardList className="w-full h-full text-red-400" strokeWidth={1.5} />
</div>
<div className="w-24 h-1 bg-red-400 mb-6"></div>
<h2 className="text-xl font-semibold text-gray-700 mb-4">

                Complete our quick form
</h2>
<p className="text-gray-600 leading-relaxed">

                Your answers help us connect you with an experienced car accident lawyer who handles your specific injury or crash type.
</p>
</div>
</article>
 
          {/* Step 2 */}
<article className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 p-8 sm:p-10">
<div className="flex flex-col items-center text-center">
<div className="w-12 h-12 rounded-full border-2 border-red-400 flex items-center justify-center mb-6 self-start">
<span className="text-red-400 font-semibold text-lg">2</span>
</div>
<div className="w-16 h-16 mb-6">
<MessageCircle className="w-full h-full text-red-400" strokeWidth={1.5} />
</div>
<div className="w-24 h-1 bg-red-400 mb-6"></div>
<h2 className="text-xl font-semibold text-gray-700 mb-4">

                Get a free consultation
</h2>
<p className="text-gray-600 leading-relaxed">

                Your matched attorney will call you to discuss the details of your case—no pressure, no obligation.
</p>
</div>
</article>
 
          {/* Step 3 */}
<article className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 p-8 sm:p-10 md:col-span-2 lg:col-span-1">
<div className="flex flex-col items-center text-center">
<div className="w-12 h-12 rounded-full border-2 border-red-400 flex items-center justify-center mb-6 self-start">
<span className="text-red-400 font-semibold text-lg">3</span>
</div>
<div className="w-16 h-16 mb-6">
<Hand className="w-full h-full text-red-400" strokeWidth={1.5} />
</div>
<div className="w-24 h-1 bg-red-400 mb-6"></div>
<h2 className="text-xl font-semibold text-gray-700 mb-4">

                Start building your case
</h2>
<p className="text-gray-600 leading-relaxed">

                They pursue the highest motor vehicle accident lawsuit payouts based on your unique situation, not a standard injury settlement calculator.
</p>
</div>
</article>
</section>
 
        {/* CTA Button */}
<div className="flex justify-center">
<button 

            className="bg-red-600 hover:bg-red-700 text-white font-semibold px-8 sm:px-12 py-4 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-red-300 text-base sm:text-lg"
onClick={() => {
              const el = document.getElementById('injury-compensation-form');
              if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
            aria-label="Find the right lawyer fast - Start your free case evaluation"
>

            Find the Right Lawyer Fast
</button>
</div>
 
        {/* Structured Data for SEO - Schema.org markup */}
<script type="application/ld+json">

          {JSON.stringify({

            "@context": "https://schema.org",

            "@type": "LegalService",

            "name": "Free Case Evaluation",

            "description": "Get a free case evaluation from experienced car accident lawyers",

            "provider": {

              "@type": "Organization",

              "name": "Your Law Firm"

            },

            "areaServed": "US",

            "hasOfferCatalog": {

              "@type": "OfferCatalog",

              "name": "Legal Services",

              "itemListElement": [

                {

                  "@type": "Offer",

                  "itemOffered": {

                    "@type": "Service",

                    "name": "Free Case Evaluation"

                  }

                }

              ]

            }

          })}
</script>
</main>
</div>

  );

}
 